<!-- Small, medium and large devices layout -->
<div class="hidden-xs mb-4 mb-product-filter"
     data-cy="mb-product-filter">
  <div *ngIf="name && code && values?.length"
       class="mb-2 mb-product-filter-name"
       data-cy="mb-product-filter-name">
    <strong [innerHTML]="('mbproduct.selectA' | mbTranslate) + ' ' + name | safeHtml"></strong>
  </div>

  <div *ngIf="((name && values?.length) || (!name && values?.length > 1)) && ((isAntibody$ | async) || (!(isAntibody$ | async) && values?.length <= productFilterOption.filterLength))"
       class="mb-product-filter-items"
       data-cy="mb-product-filter-items">
    <div class="mr-2 mb-2 cursor-pointer mb-product-filter-item"
         [attr.data-cy]="'mb-product-filter-item-' + i"
         *ngFor="let value of values; index as i"
         [class.active]="value.active"
         (click)="applyFilter(value)">
      <strong [innerHTML]="value?.name | safeHtml"></strong>
    </div>
  </div>

  <div *ngIf="!(isAntibody$ | async) && values?.length > productFilterOption.filterLength"
       ngbDropdown
       #dropdown="ngbDropdown"
       class="field-wrapper">
    <button type="button"
            [ngClass]="[dropdown.isOpen() ? 'mb-show-dropdown': '','btn btn-outline-primary mb-dropdown text-left']"
            ngbDropdownToggle
            data-cy="mb-pdp-filter-dropdown-button">
       <span class="mb-selected-dropdown-value"
             data-cy="mb-pdp-filter-selected-value"
             [innerHTML]="selectedFilterValue | safeHtml"></span>
       <img [src]="dropdown.isOpen() ? '../../../../../../assets/images/Icon_accordion_m-up_white.svg' : '../../../../../../assets/images/Icon_accordion_m-down.svg'"
            class="mb-dropdown-arrow"
            alt="filter dropdown"
            title="filter dropdown"
            data-cy="mb-pdp-filter-dropdown">
    </button>
    <div ngbDropdownMenu data-cy="mb-pdp-filter-dropdown-menu">
      <div class="mb-filter-dropdown-scrollable-list">
        <div ngbDropdownItem
             *ngFor="let value of values; index as i"
             [attr.data-cy]="'mb-pdp-filter-dropdown-item' + i"
             (click)="applyFilter(value)"
             [innerHTML]="value?.name | safeHtml">
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End of small, medium and large devices layout -->


<!-- Extra small devices layout -->
<div *ngIf="code && ((name && values?.length) || (!name && values?.length > 1))"
     class="hidden-sm hidden-md hidden-lg hidden-xl text-center mb-product-filter-xs"
     data-cy="mb-product-filter-xs">
  <div class="field-wrapper" ngbDropdown
       #dropdownMobile="ngbDropdown">
    <button type="button"
            [ngClass]="[dropdownMobile.isOpen() ? 'mb-show-dropdown': '','btn btn-outline-primary mb-dropdown text-left']"
            ngbDropdownToggle
            data-cy="mb-pdp-filter-dropdown-button-mobile">
      <span class="mb-selected-dropdown-value"
           data-cy="mb-pdp-filter-selected-value"
           [innerHTML]="selectedFilterValue | safeHtml">
      </span>
      <img [src]="dropdownMobile.isOpen() ? '../../../../../../assets/images/Icon_accordion_m-up_white.svg' : '../../../../../../assets/images/Icon_accordion_m-down.svg'"
           class="mb-dropdown-arrow"
           alt="filter dropdown"
           title="filter dropdown"
           data-cy="mb-pdp-filter-dropdown">
    </button>
    <div ngbDropdownMenu>
      <div class="mb-filter-dropdown-scrollable-list">
        <div ngbDropdownItem
             *ngFor="let value of values; index as i"
             [attr.data-cy]="'mb-pdp-filter-dropdown-mobile-item' + i"
             (click)="applyFilter(value)"
             [innerHTML]="value?.name | safeHtml">
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End of extra small devices layout -->

